// JS activa clases CSS y desactiva para mostrar solo un unico elemeto con esa clase CSS, Ej menu mobile

$(document).ready(function(){
    // variables
    const ref = document.location.href

    // acciones
    tabUrl()

    $('body').on('click', '.js-tab__action', function(event) {
        tabItems($(this))
    })

    $('body').on('mouseover', '.js-tab__action', function(event) {
        if ( $(this).data('tab__hover') ) {
            tabItems($(this))
        }
    })

    $('body').on('change', '.js-tab__action-select', function(event) {
        tabItemsSelect($(this))
    })

    // funciones
    function tabItems(action) {
        let context_self

        $('.js-tab__context').each( function (){
            if ( action.data('tab__id') == $(this).data('tab__id') ) {
                context_self = $(this).data('tab__option')
            }
        })

        if (context_self == true) {
            tabTabContent(action)
        }else{
            const check = action.hasClass(action.data('tab__active'))
            if ( check ) {
                tabTabclean(action)
                tabContentsClean(action)
            }else{
                tabTabContent(action)
            }
        }
    }

    function tabTabContent(action) {
        $('.js-tab__content').each( function (){
            if (action.data('tab__id') == $(this).data('tab__id')) {
                tabTabclean(action)
                tabContentsClean(action)
                tabTabActive(action)
                tabContentsActive(action)
            }
        })
    }
    
    function tabTabclean(action) {
        $('.js-tab__action').each( function (){
            if (action.data('tab__id') == $(this).data('tab__id')) {
                $(this).removeClass( $(this).data('tab__active') )
            }
        })
    }

    function tabTabActive(action) {
        $('.js-tab__action').each( function (){
            if (action.data('tab__id') == $(this).data('tab__id')) {
                if (action.data('tab__tab') == $(this).data('tab__tab')) {
                    $(this).toggleClass( $(this).data('tab__active') )
                }
            }
        })
    }

    function tabContentsClean(action) {
        $('.js-tab__content').each( function (){
            if (action.data('tab__id') == $(this).data('tab__id')) {
                $(this).removeClass( $(this).data('tab__active') )
            }
        })
    }

    function tabContentsActive(action) {
        $('.js-tab__content').each( function (){
            if (action.data('tab__id') == $(this).data('tab__id')) {
                if (action.data('tab__tab') == $(this).data('tab__tab')) {
                    $(this).toggleClass( $(this).data('tab__active') )
                }
            }
        })
    }

    // // // 

    function tabItemsSelect(action) {
        let context_self

        $('.js-tab__context').each( function (){
            if ( action.data('tab__id') == $(this).data('tab__id') ) {
                context_self = $(this).data('tab__option')
            }
        })

        if (context_self == true) {
            tabTabContentSelect(action)
        }else{
            const check = action.hasClass(action.data('tab__active'))
            if ( check ) {
                tabTabclean(action)
                tabContentsClean(action)
            }else{
                tabTabContentSelect(action)
            }
        }
    }

    function tabTabContentSelect(action) {
        $('.js-tab__content').each( function (){
            if (action.data('tab__id') == $(this).data('tab__id')) {
                tabTabclean(action)
                tabContentsClean(action)
                tabTabActiveSelect(action)
                tabContentsActiveSelect(action)
            }
        })
    }

    function tabTabActiveSelect(action) {
        $('.js-tab__action').each( function (){
            if (action.data('tab__id') == $(this).data('tab__id')) {
                if (action.val() == $(this).data('tab__tab')) {
                    $(this).toggleClass( $(this).data('tab__active') )
                }
            }
        })
    }

    function tabContentsActiveSelect(action) {
        $('.js-tab__content').each( function (){
            if (action.data('tab__id') == $(this).data('tab__id')) {
                if (action.val() == $(this).data('tab__tab')) {
                    $(this).toggleClass( $(this).data('tab__active') )
                }
            }
        })
    }

    // 

    function tabUrl() {
        sort_self = ref.split('#')

        if (sort_self[1]) {
            $('.js-tab__context').each( function (){
                const action_url = $(this)

                if ( action_url.data('tab__url') ) {
                    $('.js-tab__content').each( function (){
                        if ( action_url.data('tab__id') == $(this).data('tab__id') ) {
                            $(this).removeClass( $(this).data('tab__active') )
                        }
                    })

                    $('.js-tab__action').each( function (){
                        if ( action_url.data('tab__id') == $(this).data('tab__id') ) {
                            $(this).removeClass( $(this).data('tab__active') )
                        }
                    })
                }
            })

            $('.js-tab__action-select').each( function (){
                $(this).val(sort_self[1])
            })
    
            $('.js-tab__action').each( function (){
                if (sort_self[1] == $(this).data('tab__tab')) {
                    $(this).toggleClass( $(this).data('tab__active') )
                }
            })
    
            $('.js-tab__content').each( function (){
                if (sort_self[1] == $(this).data('tab__tab')) {
                    $(this).toggleClass( $(this).data('tab__active') )
                }
            })
        }

    }
})
